import { useEffect } from 'react'

export function useUtmify() {
  useEffect(() => {
    // === 1. UTMify UTM capture script ===
    if (!document.querySelector('script[src*="utmify.com.br/scripts/utms"]')) {
      const utmScript = document.createElement('script')
      utmScript.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js'
      utmScript.setAttribute('data-utmify-prevent-xcod-sck', '')
      utmScript.setAttribute('data-utmify-prevent-subids', '')
      utmScript.async = true
      utmScript.defer = true

      const head = document.head || document.getElementsByTagName('head')[0]
      if (head.firstChild) {
        head.insertBefore(utmScript, head.firstChild)
      } else {
        head.appendChild(utmScript)
      }
    }

    // === 2. UTMify Pixel tracking script ===
    if (!document.querySelector('script[src*="utmify.com.br/scripts/pixel"]')) {
      // Set pixelId globally before loading the pixel script
      ;(window as any).pixelId = '69a0ff003be451e896643410'

      const pixelScript = document.createElement('script')
      pixelScript.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js'
      pixelScript.async = true
      pixelScript.defer = true

      const head = document.head || document.getElementsByTagName('head')[0]
      head.appendChild(pixelScript)
    }
  }, [])
}
